import { render, staticRenderFns } from "./bankInfo.vue?vue&type=template&id=a6e34436&scoped=true"
import script from "./bankInfo.vue?vue&type=script&lang=js"
export * from "./bankInfo.vue?vue&type=script&lang=js"
import style0 from "./bankInfo.vue?vue&type=style&index=0&id=a6e34436&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6e34436",
  null
  
)

export default component.exports